import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateSaleInvoiceInstalmentTable } from 'store/saleInvoices/services/patchUpdateSaleInvoiceInstalmentTable';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

// Explicit user saves — the slice pairs this thunk with snackbars.
export const updateInstalmentTable = createAsyncThunk(
  'saleInvoices/updateInstalmentTable',
  async ({ tableId, changes }, { getState }) => {
    if (!tableId) {
      throw new Error('No instalment table id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const updatedInstalmentTable = await patchUpdateSaleInvoiceInstalmentTable(
      selectedProjectId,
      tableId,
      changes
    );

    return updatedInstalmentTable;
  }
);
